<enhanced-help
    componentName="equipment-details"
    [compact]="true"
></enhanced-help>
<div class="container-with-footer">
    <div class="contents">
        <div class="data">
            <span class="display-label">Equipment Category</span>
            {{
                equipment.equipmentType.equipmentCategory
                    | formatEquipmentCategory
            }}
        </div>

        <div class="data">
            <span class="display-label">Make</span>
            {{ equipment.equipmentType.make }}
        </div>

        <div class="data">
            <span class="display-label">Model</span>
            {{ equipment.equipmentType.model }}
        </div>

        <div class="data">
            <span class="display-label">Name</span>
            {{ equipment.name }}
        </div>

        <div class="data">
            <span class="display-label">Estimated Procurement Date</span>
            {{ equipment.purchaseDate | formatDate }}
        </div>

        <div class="data">
            <span class="display-label">Manufacturer Serial Number</span>
            {{ equipment.manufacturerSerialNumber }}
        </div>

        <div class="data">
            <span class="display-label">Status</span>
            {{ equipment.status | formatResourceStatus }}
        </div>

        <div class="data" *ngIf="equipment.status === 'DISPOSED'">
            <span class="display-label">Disposal Date</span>
            {{ equipment.disposalDate | formatDate }}
        </div>

        <div class="data">
            <span class="display-label">NFC ID</span>
            {{ equipment.nfcId }}
        </div>

        <div class="data">
            <span class="display-label">Current Firmware Version</span>
            {{ equipment.currentFirmwareVersion }}
        </div>

        <div class="data">
            <span class="display-label">Equipment Classification</span>
            {{ equipment.isDummy ? 'Dummy Equipment' : 'Real Equipment' }}
        </div>

        <div class="data">
            <span class="display-label">Owner</span
            >{{ equipment.organisation | formatOrganisation }}
        </div>

        <div *ngIf="hasCustodian" class="data">
            <span class="display-label">Custodian</span
            >{{ equipment.custodian | formatOrganisation | defaultTo: 'Owner' }}
        </div>

        <div class="data">
            <span class="display-label">Maintenance Organisation</span
            >{{ equipment.maintenanceOrganisation | formatOrganisation }}
        </div>
    </div>
    <!-- 
    <h4 class="section-heading top-buffer">
        <span>Attachments</span>
        <div></div>
    </h4>

    <div class="row top-buffer">
        <div class="col-xs-12">
            <attachment-list
                [attachmentsHandler]="attachmentsHandler"
                [allowUploads]="false"
                [allowDelete]="false"
                [allowEdit]="false"
                [parentPromiseTracker]="promiseTracker"
                permissions
            ></attachment-list>
        </div>
    </div> -->
    <div class="action-container">
        <button
            *ngIf="equipment.availableActions.hasDelete && isOwner"
            [disabled]="!equipment.availableActions.canDelete"
            class="btn btn-danger pull-left"
            type="button"
            (click)="deleteEquipment()"
        >
            <span class="fal fa-trash-alt"></span>
            Delete
        </button>
        <button
            *ngIf="isSystemAdmin"
            [disabled]="working"
            class="btn btn-danger pull-left"
            type="button"
            (click)="openTransferDialogue()"
        >
            Transfer To Organisation
        </button>

        <div
            class="btn-group"
            dropdown
            [dropup]="true"
            *ngIf="printOptions != null && printOptions.length > 0"
        >
            <button
                id="reports-button-container"
                dropdownToggle
                type="button"
                class="btn btn-default dropdown-toggle"
                aria-controls="dropdown-container"
            >
                Reports
                <span class="caret"></span>
            </button>
            <ul
                id="reports-dropdown-container"
                *dropdownMenu
                class="dropdown-menu dropdown-menu-right"
                role="menu"
                aria-labelledby="reports-button-container"
            >
                <li role="menuitem" *ngFor="let report of printOptions">
                    <a class="dropdown-item" (click)="report.print()">{{
                        report.name
                    }}</a>
                </li>
            </ul>
        </div>
        <div
            *ngIf="hasManageOptions && canEdit"
            class="btn-group"
            dropdown
            [dropup]="true"
            [isDisabled]="working"
        >
            <button
                id="button-container"
                dropdownToggle
                type="button"
                class="btn btn-default dropdown-toggle"
                aria-controls="dropdown-container"
                [ngClass]="{ disabled: working }"
            >
                Manage
                <span class="caret"></span>
            </button>
            <ul
                id="dropdown-container"
                *dropdownMenu
                class="dropdown-menu dropdown-menu-right"
                role="menu"
                aria-labelledby="button-container"
            >
                <li role="menuitem" *ngIf="canRetireEquipment">
                    <a class="dropdown-item" (click)="retireEquipment()"
                        >Retire Equipment</a
                    >
                </li>
                <li role="menuitem" *ngIf="canMarkUnderMaintenance">
                    <a
                        class="dropdown-item"
                        (click)="markEquipmentUnderMaintenance()"
                        >Mark as Under Maintenance</a
                    >
                </li>
                <li role="menuitem" *ngIf="canMarkServiceable">
                    <a
                        class="dropdown-item"
                        (click)="markEquipmentServiceable()"
                        >Mark as Serviceable</a
                    >
                </li>
                <li role="menuitem" *ngIf="canMarkUnserviceable">
                    <a
                        class="dropdown-item"
                        (click)="markEquipmentUnserviceable()"
                        >Mark as Unserviceable</a
                    >
                </li>
                <li role="menuitem" *ngIf="canDisposeEquipment">
                    <a class="dropdown-item" (click)="disposeEquipment()"
                        >Dispose Equipment</a
                    >
                </li>
            </ul>
        </div>

        <button
            *ngIf="equipment.availableActions.hasEdit && isOwner"
            [disabled]="!equipment.availableActions.canEdit"
            class="btn btn-primary"
            type="button"
            (click)="editEquipment()"
            data-cy="equipmentEditButton"
        >
            Edit
        </button>
    </div>
</div>
